import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './HeroSection.css';

const HeroSection = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });


  useEffect(() => {
    // Set hackathon date (one-day event: October 11, 2025 at 8:00 AM)
    const hackathonDate = new Date('2025-10-11T08:00:00').getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = hackathonDate - now;

      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000)
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleLogoClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Logo clicked!'); // Debug log
  };

  const handleTouchStart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Logo touched!'); // Debug log
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-background">
        <div className="wave-dots-container">
          <img src="/wave-dots.svg" alt="Futuristic wave dots" className="wave-dots-svg" />
        </div>
      </div>
      
      <div className="container">
        <motion.div 
          className="hero-content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div 
            className="hero-logo" 
            variants={itemVariants}
            onClick={handleLogoClick}
            onTouchStart={handleTouchStart}
            style={{ cursor: 'pointer' }}
          >
            <div className="gradient-circle"></div>
            <img 
              src="/logo%20black.svg" 
              alt="هاكاثون الطيرة" 
              className="main-logo" 
              onError={(e) => {
                console.log('Logo failed to load, trying alternative path');
                e.target.src = '/logo.png';
              }}
            />
          </motion.div>
          
          <motion.div className="countdown-timer" variants={itemVariants}>
            <div className="countdown-item">
              <div className="countdown-number">{timeLeft.seconds}</div>
              <div className="countdown-label">ثوان</div>
            </div>
            <div className="countdown-item">
              <div className="countdown-number">{timeLeft.minutes}</div>
              <div className="countdown-label">دقائق</div>
            </div>
            <div className="countdown-item">
              <div className="countdown-number">{timeLeft.hours}</div>
              <div className="countdown-label">ساعات</div>
            </div>
            <div className="countdown-item">
              <div className="countdown-number">{timeLeft.days}</div>
              <div className="countdown-label">أيام</div>
            </div>
          </motion.div>
          
          <motion.div className="hero-cta" variants={itemVariants}>
            <button 
              onClick={() => {
                document.getElementById('registration')?.scrollIntoView({ 
                  behavior: 'smooth',
                  block: 'start'
                });
              }}
              className="btn-primary hero-btn"
            >
              <span className="btn-emoji">👨‍💻</span>
              سجل الآن
            </button>
          </motion.div>
        </motion.div>
      </div>

    </section>
  );
};

export default HeroSection;
